module.exports = require('./head');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/first.js
 ** module id = 1179
 ** module chunks = 0
 **/